// Frontend copy of criteria_validator.rb
function CriteriaValidator (criteria, fields, criteriaLayers) {
    const errors = {}
    function addError(field, message) {
        if (errors[field] == null) {
            errors[field] = [message];
        } else {
            errors[field].push(message);
        }
        // console.log(`${field}: ${message}`);
    }

    
    // Check that all required fields are include
    // Would need to go in validateBranch to support nested isRequired
    for (const field in fields) {
        if (fields[field].isRequired && !Boolean(criteria?.children?.find(c => c.field === field))) {
            addError(field, 'Is required');
        }
    }

    // If no criteria then that is also fine
    if (criteria == null) {
        return true;
    }
    // Loop through each criteria
    validateBranch(criteria, fields);
    return errors;

    function validateBranch(branch, fields) {
        if (fields == null) {
            addError(branch?.field || '*', 'No search fields found for layer');
            return false;
        }
        const type = branch.type;
        switch (type) {
            case 'group':
                break;
            case 'group-rule':
            case 'rule':
                const field = branch.field;
                if (field == null) {
                    addError('*', 'No field found');
                    return false
                }
                const fieldConfig = fields[field]
                if (fieldConfig == null) {
                    addError(field, 'No field config found');
                    return false
                }
                switch (fieldConfig.type) {
                    case 'area':
                        validateArea(branch);
                        break;
                    case 'select':
                        validateSelect(branch);
                        break;
                    case 'multiselect':
                        validateMultiSelect(branch);
                        break;
                    case 'within':
                    case 'notwithin':
                        validateWithin(branch);
                        break;
                    case 'intersects':
                    case 'notintersects':
                        validateIntersects(branch);
                        break;
                    // Layer is legacy but can sort of work
                    case 'layer':
                        validateLayer(branch);
                        break;
                    case 'integer':
                        validateNumber(branch);
                        break;
                    case 'date':
                        validateDate(branch);
                        break;
                    case 'string':
                        validateString(branch);
                        break;
                    case 'multistring':
                        validateMultiString(branch);
                        break;
                    default:
                        addError(field, 'Invalid field config type');
                        return false;
                }
                break;
            default:
                addError(field, 'No type found for branch');
                return false;
        }

        // Validate children of group, group rules will handle themselves directly if they need to validate their children
        if (type === 'group') {
            const children = branch.children;
            if (children != null) {
                for (const child of children) {
                    validateBranch(child, fields)
                }
            }
        }
    }

    // Utility - Validate a unit of measurement (area or distance) as must exists, be a number and greater than 0
    // ToDo need to pass info that allows for better error message
    function validateMeasurement(field, value) {
        if (value == null) {
            addError(field, 'Missing value');
            return false;
        }
        if (typeof value != 'number' || isNaN(value)) {
            addError(field, 'Non-numeric value');
            return false;
        }
        if (value < 0) {
            addError(field, 'Negative value');
            return false;
        }
        return true;
    }

    // Utility - Validate whether value exists and is one of the options in th eprovided array
    // ToDo need to pass info that allows for better error message
    function validateValueInArray(field, value, array) {
        if (value == null) {
            addError(field, 'Missing value');
            return false;
        }
        if (!array.includes(value)) {
            addError(field, 'Invalid value');
            return false;
        }
        return true;
    }

    function validateNumber(branch) {
        const properties = branch?.properties;
        const operator = properties?.operator;
        const field = branch?.field;
        if (operator == null) {
            addError(field, 'Missing operator');
            return false;
        }
        switch (operator) {
            case 'greater':
                return validateMeasurement(field, properties?.value0);
            case 'less':
                return validateMeasurement(field, properties?.value1);
            case 'between':
                const value0 = properties?.value0;
                const value0_valid = validateMeasurement(field, value0);
                const value1 = properties?.value1;
                const value1_valid = validateMeasurement(field, value1);
                if (value0_valid && value1_valid) {
                    if (value0 > value1) {
                        addError(field, 'Min value is larger then max value');
                        return false;
                    }
                    return true;
                } else {
                    return false;
                }
            default:
                addError(field, 'Invalid operator');
                return false;
        }
    }

    function validateArea(branch) {
        const field = branch?.field;
        validateNumber(branch)
        const properties = branch?.properties;
        const unit = properties?.unit
        validateValueInArray(field, unit, ['ac', 'ha', 'm2', 'sqft']);
    }

    function validateSelect(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const operator = properties?.operator;
        const value = properties?.value;
        validateValueInArray(field, operator, ['==', '!=']);
        if (value == null) {
            addError(field, 'Missing value');
        }
        // ToDo validate that select choice is valid based on possible choices
        // Use validate_value_in_array to do this by passing options
    }

    function validateMultiSelect(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const operator = properties?.operator;
        const values = properties?.values;
        validateValueInArray(field, operator, ['==', '!=']);
        if (values == null) {
            addError(field, 'Missing value');
        } else if (!Array.isArray(values)) {
            addError(field, 'Invalid non-array value');
        } else if (values.length === 0) {
            addError(field, 'Empty array');
        }
        // ToDo validate that select choice is valid based on possible choices
        // Use validate_value_in_array to do this by passing options
    }

    function validateIntersects(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const layerSystemName = properties?.layer;
        if (layerSystemName == null) {
            addError(field, 'Missing layer');
            return false;
        }
        const layer = criteriaLayers[layerSystemName];
        if (layer == null) {
            addError(field, 'Invalid layer');
            return false;
        }
        const children = branch?.children;
        if (children != null) {
            const fields = layer?.subfields;
            for (const child of children) {
                validateBranch(child, fields);
            }
        }
    }

    function validateWithin(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const layerSystemName = properties?.layer;
        if (layerSystemName == null) {
            addError(field, 'Missing layer');
            return false;
        }
        const layer = criteriaLayers[layerSystemName];
        if (layer == null) {
            addError(field, 'Invalid layer');
            return false;
        }

        const value = properties?.value;
        validateMeasurement(field, value);
        const unit = properties?.unit;
        validateValueInArray(field, unit, ['m', 'km', 'mi']);

        const children = branch?.children;
        if (children != null) {
            const fields = layer?.subfields;
            for (const child of children) {
                validateBranch(child, fields);
            }
        }
    }

    function validateLayer(branch) {
        const field = branch?.field;
        addError(field, 'Invalid legacy layer type');
        return false;
    }

    // Utility - Validate a unit of measurement (area or distance) as must exists, be a number and greater than 0
    // ToDo need to pass info that allows for better error message
    function validateDateFormat(field, value) {
        if (value == null) {
            addError(field, 'Missing value');
            return false;
        }
        // Check format of date vs. expected format
    }

    function validateDate(branch) {
        const properties = branch?.properties;
        const operator = properties?.operator;
        const field = branch?.field;
        if (operator == null) {
            addError(field, 'Missing operator');
            return false;
        }
        switch (operator) {
            case 'after':
                return validateDateFormat(field, properties?.value0);
            case 'before':
                return validateDateFormat(field, properties?.value1);
            case 'between':
                const value0 = properties?.value0;
                const value0_valid = validateDateFormat(field, value0);
                const value1 = properties?.value1;
                const value1_valid = validateDateFormat(field, value1);
                if (value0_valid && value1_valid) {
                    if (value0 > value1) {
                        addError(field, 'Min value is larger then max value');
                        return false;
                    }
                    return true;
                } else {
                    return false;
                }
            default:
                addError(field, 'Invalid operator');
                return false;
        }
    }

    function validateString(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const operator = properties?.operator;
        const value = properties?.value;
        validateValueInArray(field, operator, ['==', 'ilike']);
        if (value == null || value == '') {
            addError(field, 'Missing value');
        } 
        // Need to also validate if exact match is required
    }

    function validateMultiString(branch) {
        const field = branch?.field;
        const properties = branch?.properties;
        const operator = properties?.operator;
        const values = properties?.values;
        validateValueInArray(field, operator, ['==', 'ilike']);
        if (values == null) {
            addError(field, 'Missing value');
        } else if (!Array.isArray(values)) {
            addError(field, 'Invalid non-array value');
        } else if (values.length === 0) {
            addError(field, 'Empty array');
        }
        // Need to also validate if exact match is required
    }
}

export default CriteriaValidator;